<template>
    <div class="bg-view bg-primary p-5">
        <b-container id="view-container" class="container bg-light" fluid="lg" variant="light" type="light">
        <b-overlay :show="loading" spinner-variant="primary">
            <p class="message">{{message}}</p>
        </b-overlay>
        </b-container>
    </div>
</template>

<script>
import publicApi from '@/services/public.js'

export default {
    data() { 
        return {
            loading: true,
            message: ""
        }
    },
    created() {
        this.saveEmail()
    },
    methods: {
        async saveEmail () {
            await publicApi.get(`/lsa/confirm/email/${this.$route.params.user}/${this.$route.params.token}`)
            .then(response => {
                this.message = response.data.message
            })
            .catch(error => {
                this.message = error.response.data.error.exception[0].message
                this.message += " Veuillez retourner sur votre espace Digital Citizen pour renseigner à nouveau votre adresse email et recevoir un nouveau lien de confirmation."
            })
            this.loading = false
        }
    }
}
</script>

<style scoped>
.message {
    font-weight: bold;
}
</style>